// extracted by css-extract-rspack-plugin
export default {"Centered":"Centered-kNGSLD","centered":"Centered-kNGSLD","MainCase":"MainCase-aPIqJA","mainCase":"MainCase-aPIqJA"};